import type { ReactNode } from "react";
import { Grid, IconButton, Tooltip } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import {
  CommuneOuCommuneAssocieeDelegueeMultiAutoWithErrorBoundary,
  CompetenceSelect,
  MetierMultiAutoWithErrorBoundary,
  PerimetreMultiAutoWithErrorBoundary,
  PosteMultiAutoWithErrorBoundary,
  TerritoireMultiAutoWithErrorBoundary,
} from "components/inputs";
import { useSearch } from "providers";

const INPUTS_SIZE = "small";

function getPosteAutoCompleteLabel(postesVacants: boolean | undefined): string {
  let label = "Postes";
  if (postesVacants != null) {
    label += postesVacants ? " vacants" : " occupés";
  }
  return label;
}

function ContactsMetiersFilters(): ReactNode {
  const { filters, setFilters, resetAllFilters } = useSearch();

  return (
    <Grid container size={12} spacing={1} sx={{ alignItems: "center" }}>
      <Grid container size="grow">
        <Grid size={{ xs: 12, md: 5, lg: 4, xl: 3 }}>
          <TerritoireMultiAutoWithErrorBoundary
            label="Territoires"
            size={INPUTS_SIZE}
            value={filters.territoires}
            onChange={(territoires) => {
              setFilters({ ...filters, territoires });
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 7, lg: 8, xl: 6 }}>
          <PerimetreMultiAutoWithErrorBoundary
            label="Périmètres"
            size={INPUTS_SIZE}
            value={filters.perimetres}
            onChange={(perimetres) => {
              setFilters({ ...filters, perimetres });
            }}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 5, lg: 3, xl: 3 }}>
          <CompetenceSelect
            label="Compétence"
            size={INPUTS_SIZE}
            value={filters.competences[0]}
            onChange={(competence) => {
              setFilters({ ...filters, competences: competence == null ? [] : [competence] });
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 7, lg: 4.5, xl: 3 }}>
          <CommuneOuCommuneAssocieeDelegueeMultiAutoWithErrorBoundary
            label="Communes"
            size={INPUTS_SIZE}
            value={filters.communesOuCommunesAssocieesDeleguees}
            onChange={(communesOuCommunesAssocieesDeleguees) => {
              setFilters({ ...filters, communesOuCommunesAssocieesDeleguees });
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6, lg: 4.5, xl: "grow" }}>
          <MetierMultiAutoWithErrorBoundary
            label="Métiers"
            size={INPUTS_SIZE}
            value={filters.metiers}
            onChange={(metiers) => {
              setFilters({ ...filters, metiers });
            }}
            groupesParNiveau
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6, lg: 12, xl: "grow" }}>
          <PosteMultiAutoWithErrorBoundary
            label={getPosteAutoCompleteLabel(filters.isPostesVacants)}
            size={INPUTS_SIZE}
            value={filters.postes}
            onChange={(postes) => {
              if (postes.length > 0) {
                setFilters({ ...filters, postes });
              } else {
                setFilters({ ...filters, postes, isPostesVacants: undefined });
              }
            }}
            onlyPostesVacants={filters.isPostesVacants}
            onOnlyPostesVacantsChange={(postesVacants) => {
              setFilters({ ...filters, postes: [], isPostesVacants: postesVacants });
            }}
          />
        </Grid>
      </Grid>
      <Grid size="auto">
        <Tooltip title="Vider tous les filtres" placement="top">
          <IconButton color="error" onClick={resetAllFilters}>
            <ClearIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
}

export default ContactsMetiersFilters;
